<div class="loader">
  <div class="animate">
  </div>
</div>
